
import pageTransition from '@/mixins/pageTransition'
import _debounce from 'lodash.debounce'

export default {
  props: {
    page: Object
  },

  mixins: [pageTransition],

  computed: {
    shouldUpdateFrameScrollHeight () {
      return this.$store.state.layout.shouldUpdateFrameScrollHeight
    }
  },

  watch: {
    shouldUpdateFrameScrollHeight: _debounce(function () {
      // console.log('SCROLL POSITION', sessionStorage.getItem('jgast-scroll-position'))
      if (sessionStorage.getItem('jgast-scroll-position')) {
        if (sessionStorage.getItem('jgast-scroll-height') && parseInt(sessionStorage.getItem('jgast-scroll-height')) === document.body.scrollHeight) {
          window.scrollTo({
            top: parseInt(sessionStorage.getItem('jgast-scroll-position')),
            behavior: 'smooth'
          })
          sessionStorage.removeItem('jgast-scroll-position')
          sessionStorage.removeItem('jgast-scroll-height')
        }
      }
    }, 400)
  },
}
